<template>
    <span>Internal.</span>
</template>

<script>
export default {
    mounted() {
        console.log('Component mounted. ')
    }
}
</script>
